import type { Vision } from './types';

export function visionFromRow(row: any): Vision {
  return {
    id: row.id,
    workspaceId: row.workspace_id,
    teamId: row.team_id ?? undefined,
    name: row.name,
    structure: row.structure ?? null,
    data: row.data ?? {},
    ratifiedAt: row.ratified_at ?? undefined,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
  };
}

export function visionToRow(vision: Partial<Vision>): any {
  const row: any = {};
  if (vision.name !== undefined) row.name = vision.name;
  if (vision.structure !== undefined) row.structure = vision.structure ?? null;
  if (vision.data !== undefined) row.data = vision.data ?? {};
  if (vision.ratifiedAt !== undefined) row.ratified_at = vision.ratifiedAt ?? null;
  return row;
}
